import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BalanceDetails from '../components/bill/balanceDetails';
import * as BillAction from '../actions/billAction';
function mapStateToProps(state) {
  return {
    billDetails: state.Bill.billDetails,
    verAccDetails: state.Bill.verAccDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...BillAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BalanceDetails);
